module.exports = __webpack_public_path__ + "static/wordpress9-2012e6504bd0c0a212c64c26ffe2e68d.png";